var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemstone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.1 52.232 12.06 7.425a2.286 2.286 0 0 0 1.208.343h15.264a2.282 2.282 0 0 0 1.207-.343L50.9 52.233a2.317 2.317 0 0 0 1.1-1.961V27.628a2.311 2.311 0 0 0-.485-1.413L31.816.887a2.372 2.372 0 0 0-3.632 0L8.485 26.215A2.311 2.311 0 0 0 8 27.628v22.644a2.316 2.316 0 0 0 1.1 1.96zM16 30.638v15.318l-6 3.516V28.519zm14-15.8L42 30.27v15.7L35.452 50h-10.9L18 45.971V30.27zm20 13.681v20.953l-6-3.516V30.638zM43.011 47.7l5.865 3.436-10.237 6.3-1.728-5.981zm-18 4.3h9.976l1.733 6H23.279zm-1.923-.549-1.728 5.981-10.237-6.3 5.866-3.432zM49.312 26.64l-5.964 2.106L31 12.869V3.1zM29 3.1v9.772L16.652 28.746l-5.964-2.106z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 31a1 1 0 0 0 .8-.4l3-4a1 1 0 1 0-1.6-1.2l-3 4A1 1 0 0 0 23 31zM24.4 34.8a1 1 0 0 0 1.4-.2l6-8a1 1 0 1 0-1.6-1.2l-6 8a1 1 0 0 0 .2 1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemstone);
export default __webpack_public_path__ + "static/media/gemstone.51de367bd36884afa8fb86ff9ddcc9ac.svg";
export { ForwardRef as ReactComponent };